import { constants } from 'helpers/constants';
import { userHasNoDocumentAlert } from 'helpers/functions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { listCurrency } from 'store/Orbita/Currency/actions';
import { listCategories } from 'store/Orbita/Product/actions';
import ModalFiscal from 'v2/components/Shared/ModalFiscal';
import { FidcBlocks } from 'v2/interfaces/product';
import productService from 'v2/services/product';

import type IProfile from 'v2/interfaces/profile';

import Wizard from './components/Wizard';
import InfoProduct from './InfoProduct';
import PhysicalProduct from './PhysicalProduct';
import ServiceProduct from './ServiceProduct';
import SubscriptionProduct from './Subscription/index';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  type: number;
}

interface NewProductState {
  profile: IProfile;
  availableToCreate: boolean;
  showModalFiscal: boolean;
  canSkipModalFiscal: boolean;
}

class NewProduct extends Component<IProps, NewProductState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      profile: null,
      availableToCreate: false,
      showModalFiscal: false,
      canSkipModalFiscal: false,
    };
  }

  handleCloseModalFiscal = () => {
    this.setState({ availableToCreate: true, showModalFiscal: false });
  };

  load = async () => {
    const { profile, hasDocument } = await userHasNoDocumentAlert();

    const { availableToCreate, blocksToCreate } = await productService.getCreateInfo();

    const showModalFiscal =
      !hasDocument || blocksToCreate?.includes(FidcBlocks.FIDC_BLOCK) || blocksToCreate?.includes(FidcBlocks.FIDC_BLOCK_WITH_POSSIBILITY_OF_SKIPPING);

    const canSkipModalFiscal = showModalFiscal && blocksToCreate?.includes(FidcBlocks.FIDC_BLOCK_WITH_POSSIBILITY_OF_SKIPPING);

    this.setState({ profile, availableToCreate, showModalFiscal, canSkipModalFiscal });
  };

  componentDidMount() {
    const qs = new URLSearchParams(window.location.search).get('type')?.toUpperCase();
    const initialSelected = constants[qs];
    const initialStep = initialSelected ? 2 : 1;

    try {
      this.props.dispatch({ type: 'RESET_PRODUCT_WIZARD_NP' });
      this.props.dispatch({ type: 'RESET_WIZARD_NP', initialStep });
      this.props.dispatch({ type: 'RESET_VALUE_WIZARD_NP', initialSelected });
      this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
      this.props.dispatch(listCategories());
      this.props.dispatch(listCurrency());
    } catch (error) {}

    this.load();
  }

  render() {
    const { type } = this.props;

    return (
      <>
        <ModalFiscal
          opened={this.state.showModalFiscal}
          onClose={this.handleCloseModalFiscal}
          onComplete={this.handleCloseModalFiscal}
          canSkip={this.state.canSkipModalFiscal}
          profile={this.state.profile}
        />
        {this.state.availableToCreate && (
          <Wizard>
            {type === constants.INFO && <InfoProduct />}
            {type === constants.PHYSICAL && <PhysicalProduct />}
            {type === constants.SERVICE && <ServiceProduct />}
            {type === constants.SUBSCRIPTION && <SubscriptionProduct />}
          </Wizard>
        )}
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    type: state.components.newProductWizard.selected,
  };
}

export default connect(mapStateToProps)(NewProduct);
